import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';
import Button from '@mui/material/Button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Page, Header, Content } from '@backstage/core-components';

interface ToolLayoutProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
}

const useStyles = makeStyles()((theme) => ({
  backBtn: {
    marginBottom: theme.spacing(2.5),
    color: theme.palette.text.secondary,
    textTransform: 'none',
    paddingLeft: 0,
    '&:hover': { color: theme.palette.primary.main, background: 'transparent' },
  },
}));

export function ToolLayout({ title, subtitle, children }: ToolLayoutProps) {
  const { classes } = useStyles();
  const navigate = useNavigate();

  return (
    <Page themeId="tool">
      <Header title={title} subtitle={subtitle} />
      <Content>
        <Button
          className={classes.backBtn}
          startIcon={<ArrowBackIcon fontSize="small" />}
          onClick={() => navigate('/tools')}
          disableRipple
        >
          Back to Tools
        </Button>
        {children}
      </Content>
    </Page>
  );
}
